'use strict';

module.exports = {
  cancel: 'cancel',
  discard: 'discard',
  save: 'save',
};
